export type VideoEmbedInfo = {
  provider: string;
  embedUrl: string;
  watchUrl: string;
  videoId: string;
};

const YOUTUBE_PATTERNS = [
  /(?:youtube\.com\/watch\?v=|youtube\.com\/shorts\/|youtu\.be\/)([\w-]{11})/i,
  /youtube\.com\/embed\/([\w-]{11})/i,
];

const VIMEO_PATTERN = /vimeo\.com\/(?:video\/)?(\d+)/i;

export function parseVideoEmbedUrl(url: string): VideoEmbedInfo | null {
  const trimmed = url.trim();
  if (!trimmed) return null;

  for (const pattern of YOUTUBE_PATTERNS) {
    const match = trimmed.match(pattern);
    if (match?.[1]) {
      const videoId = match[1];
      return {
        provider: 'youtube',
        videoId,
        watchUrl: `https://www.youtube.com/watch?v=${videoId}`,
        embedUrl: `https://www.youtube-nocookie.com/embed/${videoId}`,
      };
    }
  }

  const vimeo = trimmed.match(VIMEO_PATTERN);
  if (vimeo?.[1]) {
    const videoId = vimeo[1];
    return {
      provider: 'vimeo',
      videoId,
      watchUrl: `https://vimeo.com/${videoId}`,
      embedUrl: `https://player.vimeo.com/video/${videoId}`,
    };
  }

  return null;
}
